import momentPackage from "moment/moment";
import "moment/locale/de";
import "moment/locale/fr";
import "moment/locale/it";

const moment = momentPackage;

export default moment;
